/// <reference types="vite-plugin-svgr/client" />
import { X as XIcon } from 'react-feather';
import SuccessIconImage from '~/assets/images/success-icon.svg?react';
import { Box, Button, Grid, IconButton, Modal } from '@mui/material';

export default function SuccessModal({
  confirmedOpen,
  handleModalClose,
}: {
  confirmedOpen: boolean;
  handleModalClose: Function;
}) {
  return (
    <Modal
      open={confirmedOpen}
      onClose={() => handleModalClose()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box
        sx={{
          borderRadius: '10px',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 600,
          bgcolor: 'rgb(246, 247, 251)',
        }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'right', p: 3 }}>
          <IconButton onClick={() => handleModalClose()}>
            <XIcon size={16} />
          </IconButton>
        </Box>

        <Grid sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <SuccessIconImage />
          <h2>Payment Confirmed</h2>
          <p>The payment has been successfully processed!</p>
        </Grid>

        <Box sx={{ pt: 3, pb: 6, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Button variant="contained" size="large" onClick={() => handleModalClose()} sx={{ width: '240px' }}>
            OK
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
